<template>
  <footer class="page-footer">
    <div class="container text-primary text-xs d-flex align-items-center">
      <div class="left-col d-flex flex-column flex-sm-row align-items-center w-100">
        <img src="../assets/logo_100.svg" class="logo mr-n4 mr-sm-0 pt-4">
        <p class="ml-sm-2 ml-md-4 pt-sm-3 pr-sm-4 text-center text-sm-left" v-html="$t('common.allRightsReserved')"></p>
      </div>
      <div class="right-col">
        <p class="pt-3"><a href="https://nissens.com/">www.nissens.com</a></p>
      </div>
    </div>
    <cookie-law theme="niss-custom"
                :message="$t('common.cookieMessage')"
                :buttonText="$t('common.cookieAgree')"></cookie-law>
  </footer>
</template>
<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    CookieLaw,
  },
};
</script>
<style lang="scss" scoped>
footer {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  background: white;
  .logo {
    max-width: 210px;
  }
  p {
    margin: 0;
    display: inline-block;
  }
}
@media screen and (max-width: 580px) {
  footer > div {
    flex-wrap: wrap;
  }
  .left-col {
    justify-content: center;
  }
  .right-col {
    width: 100%;
    text-align: center;
    padding-bottom: 2rem;
  }
}
</style>
